import React from 'react';
import {
  FormGroup,
  Label,
  FormFeedback,
} from 'reactstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import es from 'date-fns/locale/es'; // the locale you want
import {FormErrors, FormValues} from '../../../types/general-types'

interface FechaNacimientoProps {
  formValues: FormValues;
  setFormValues: (props:any) => void;
  formErrors: FormErrors;
  setFormErrors: (props:any) => void;
}

registerLocale('es', es);

const FechaNacimiento = (props: FechaNacimientoProps) => {
  const { formErrors, formValues, setFormValues, setFormErrors } = props;

  const handleDateChange = (
    date: Date | null,
    event: React.SyntheticEvent<any> | undefined,
  ) => {
    setFormValues((prevFormValues:any) => ({
      ...prevFormValues,
      birthday: date,
    }));
    setFormErrors((formErrors:any) => ({
      ...formErrors,
      birthday: '',
    }));
  };

  return (
    <FormGroup>
      <Label for="birthday">Fecha de nacimiento:</Label>
      <DatePicker
        className={
          'form-control ' + (formErrors.birthday ? 'is-invalid' : '')
        }
        showYearDropdown
        dateFormat="dd/MM/yyyy"
        yearDropdownItemNumber={40}
        scrollableYearDropdown
        timeIntervals={360}
        locale="es"
        selected={
          formValues.birthday ? new Date(formValues.birthday) : null
        }
        onChange={handleDateChange}
      />
      {formErrors.birthday && (
        <FormFeedback style={{ display: 'block' }}>
          {formErrors.birthday as string}
        </FormFeedback>
      )}
    </FormGroup>
  );
};

export default FechaNacimiento;